export const WownetContentType = {
  HOME: "HOME",
  INFO: "INFO",
  ALARM: "ALARM",
}
